import React, { Fragment, useEffect } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  SpacerV,
  FeatureCard,
  Stats,
} from "../components/Hero";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WindowIcon from "@mui/icons-material/Window";
import TabIcon from "@mui/icons-material/Tab";
import DvrIcon from "@mui/icons-material/Dvr";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import Lottie from "react-lottie";

export default function Software() {
  useEffect(() => {}, []);

  const state = useSelector((state) => state);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <Hero
          background={
            "linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%)"
          }
          title="Software Development"
          subtitle={
            <div>
              <p>
                Our software development expertise ensures scalable,
                high-quality, and innovative solutions tailored to your business
                needs. Here’s why we’re the right choice for your project:
              </p>
              {!state.auth.isMobile ? (
                <ul>
                  <li>
                    <strong>Custom Solutions</strong>: We build tailor-made
                    software that aligns perfectly with your business objectives
                    and operational needs.
                  </li>
                  <li>
                    <strong>Scalability & Performance</strong>: Our software is
                    designed to grow with your business, ensuring high
                    performance and reliability.
                  </li>
                  <li>
                    <strong>Cutting-Edge Technologies</strong>: We leverage the
                    latest frameworks, programming languages, and development
                    methodologies to create efficient and future-proof
                    applications.
                  </li>
                </ul>
              ) : (
                ""
              )}
              <p>
                By hiring us, you gain a dedicated partner committed to
                delivering robust, innovative, and high-performing software
                solutions that drive success.
              </p>
            </div>
          }
        />

        <ContentSideBySideInv
          title="Key benefits of Software Solutions for Business"
          subtitle={
            <div style={{ marginLeft: "15px" }}>
              <div style={{ display: "flex", color: "black", fontWeight: 600 }}>
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "orange",
                    marginRight: "15px",
                  }}
                />
                Better Decision-Making
              </div>
              Artificial Intelligence (AI) and Machine Learning (ML) speed up
              data processing and programming, which reduces time and effort in
              making better decisions.
              <br />
              <br />
              <div style={{ display: "flex", color: "black", fontWeight: 600 }}>
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "blue",
                    marginRight: "15px",
                  }}
                />
                Accuracy{" "}
              </div>
              Prevent human errors and ensure accurate results with the help of
              Artificial Intelligence in your processes.
              <br />
              <br />
              <div style={{ display: "flex", color: "black", fontWeight: 600 }}>
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "teal",
                    marginRight: "15px",
                  }}
                />
                Process Optimization
              </div>
              Machine learning can be used to streamline corporate processes and
              help find anomalies in them to boost efficiency.
            </div>
          }
          image={
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: require("../img/work.json"),
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              height={state.auth.isMobile ? 350 : 500}
              width={state.auth.isMobile ? 350 : 500}
              isStopped={false}
              isPaused={false}
            />
          }
        />
        <SpacerV height={"100px"} />
        <SpacerV height={"100px"} />
        <ThreeSideBySide
          background={
            "linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%)"
          }
          spacing={5}
          subtitle1={
            <Fragment>
              <FeatureCard
                minHeight={"50vh"}
                title={"Software Development"}
                text={
                  "Our approach to creating solutions that perfectly fit your needs, and which involves developing customized software that enhances efficiency and innovation. We seamlessly integrate with your existing systems and our softwares work right out of the box."
                }
                icon={
                  <TravelExploreIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"50vh"}
                title={" Software Consulting"}
                text={`Our experts will provide insightful strategies, technology
                recommendations, and detailed project roadmaps. They will align
                with emerging trends such as advanced cybersecurity and cloud
                computing technologies.`}
                icon={
                  <BlurOnIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
          subtitle2={
            <Fragment>
              <FeatureCard
                minHeight={"50vh"}
                title={"Software Maintenance"}
                text={`We are here to turn your complex challenges into simple and
                streamlined solutions. We engineer comprehensive and scalable
                software solutions. Our agile team has intuitive interfaces to
                work fast and smart tot deliver projects quickly`}
                icon={
                  <DvrIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"50vh"}
                title={"Software Delivery"}
                text={`We offer remote expert collaboration for designing, developing,
              and delivering top-notch software solutions for you. Our support
              is tailored exactly to drive your business’s success in the
              dynamic tech world of 2024.`}
                icon={
                  <TabIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
          subtitle3={
            <Fragment>
              <FeatureCard
                minHeight={"50vh"}
                title={"All round Software Solution"}
                text={`Our devoted support will take your business excellence to its
                peak. They will ensure your software stays robust, secure, and
                consistently updated. It will help you reduce downtime and
                enhance user satisfaction and improve performance.`}
                icon={
                  <WindowIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"50vh"}
                title={"Software Integration"}
                text={`Our software integration assistance will seamlessly connect your
              digital ecosystem. Our skilled integration services streamline
              your processes and optimize data flow. It will increase
              efficiency and organization.`}
                icon={
                  <DoubleArrowIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
        />
        <Stats />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
